import {
  Actions,
  BoxesSkeleton,
  ErrorAlert,
  Header,
  Link,
  LinkBtn,
  PencilSquareIcon,
  SwitchInput,
  useCanShow,
  useDelete,
  useFetchData,
  useToggle,
} from "@";
import { getPages, toggleActive } from "./utils/api";

const Index = () => {
  const links = [{ name: "صفحات الموقع الالكترونى", link: "" }];
  const canEditSitePages = useCanShow("editSitePages");

  // Fetch data for pages
  const { data, setData, isLoading, error, fetchData } = useFetchData({
    noPgn: true,
    fun: getPages,
  });

  // Toggle active state of pages
  const { active } = useToggle(setData, toggleActive);

  // Handle page deletion
  const { deleteHandler } = useDelete(data, setData, "pages");

  return (
    <>
      {/* error alert */}
      <ErrorAlert reload={fetchData} show={error} />

      {/* header */}
      <Header title="صفحات الموقع الالكترونى" links={links}>
        {canEditSitePages && (
          <LinkBtn
            className="btn-purple-900"
            to="/website/pages/create"
            create
          />
        )}
      </Header>

      {/* table */}
      {isLoading ? (
        <BoxesSkeleton />
      ) : (
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {/* other pages */}
          {data?.map((item) => (
            <div key={item.id} className="card relative mb-0 p-4">
              <div className="sm:flex sm:items-center sm:justify-between">
                <h3 className="text-xl dark:text-gray-400">{item.pageTitle}</h3>
                <div className="flex items-center justify-between">
                  {canEditSitePages && (
                    <Actions
                      notShow
                      row={item}
                      url="website/pages"
                      delete={deleteHandler}
                    />
                  )}
                  {canEditSitePages && (
                    <SwitchInput
                      checked={item.isActive}
                      change={() => active(item.id, !item.isActive)}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}

          {/* privacy and terms conditions pages */}
          <div className="card relative mb-0 flex items-center justify-between p-4">
            <h3 className="text-xl dark:text-gray-400">سياسة الخصوصية</h3>
            {canEditSitePages && (
              <Link className="icon-style" to="/website/pages/privacy-policy">
                <PencilSquareIcon className="w-6" />
              </Link>
            )}
          </div>
          <div className="card relative mb-0 flex items-center justify-between p-4">
            <h3 className="text-xl dark:text-gray-400">الشروط والاحكام</h3>
            {canEditSitePages && (
              <Link className="icon-style" to="/website/pages/terms-conditions">
                <PencilSquareIcon className="w-6" />
              </Link>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Index;
